const state = {

    messages: [],

}

const getters = {

    messages: state => state.messages,

}

const actions = {

  growl ({ commit }, data) {
    
    const defaults = {
      color: 'grey',
      status: true,
      content: '',
      timeout: 3000
    }

    if( typeof data == 'string' )
      data = { content: data }
    
    commit( 'pushGrowl', { 
      ...defaults,
      ...data 
    })

  },  

}

const mutations = {

    pushGrowl (state, message) {
      
      state.messages.push(message)

    },

}

const growler = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default growler